(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cv-podcast-card"] && !Shopify.designMode) return;
  try {
    // Délégation au niveau du document : le snippet est rendu une fois par
  // épisode, mais ce bloc n'est inclus qu'une seule fois dans le bundle.
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-podcast-toggle]');

    if (toggle) {
      const card = toggle.closest('.cv-podcast-image');
      const panel = card && card.querySelector('[data-podcast-panel]');
      if (!panel) return;

      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';

      // Un seul panneau ouvert à la fois : deux visuels superposés côte à côte
      // seraient illisibles.
      document.querySelectorAll('[data-podcast-panel].is-open').forEach((other) => {
        if (other === panel) return;
        other.classList.remove('is-open');
        other.setAttribute('aria-hidden', 'true');
        const otherToggle = other.parentElement.querySelector('[data-podcast-toggle]');
        if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
      });

      toggle.setAttribute('aria-expanded', String(willOpen));
      panel.classList.toggle('is-open', willOpen);
      panel.setAttribute('aria-hidden', String(!willOpen));
      return;
    }

    // Clic hors d'un panneau ouvert : on referme.
    if (!event.target.closest('[data-podcast-panel]')) {
      document.querySelectorAll('[data-podcast-panel].is-open').forEach((panel) => {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        const t = panel.parentElement.querySelector('[data-podcast-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-podcast-panel].is-open').forEach((panel) => {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      const t = panel.parentElement.querySelector('[data-podcast-toggle]');
      if (t) {
        t.setAttribute('aria-expanded', 'false');
        t.focus();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
